/**
 * BPP Backend API (Version: 1.0.0.0)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum BoatConstructionType {
    Verdraenger = 'Verdraenger',
    Gleiter = 'Gleiter'
  }

    export const BoatConstructionTypeTranslocoMap: Record<BoatConstructionType, string> = {
    [BoatConstructionType.Verdraenger]: 'boatConstructionType.verdraenger',
    [BoatConstructionType.Gleiter]: 'boatConstructionType.gleiter',
    };

    export const BoatConstructionTypeOptions = [
  { value: BoatConstructionType.Verdraenger, labelKey: 'boatConstructionType.verdraenger' },
  { value: BoatConstructionType.Gleiter, labelKey: 'boatConstructionType.gleiter' },
    ];

